import React from 'react'
import styled from 'styled-components'
import { Grid as BaseGrid, TableCell } from '@material-ui/core'
import { Close } from '@material-ui/icons'

export const Root = styled.div`
  padding: 19px 20px 40px;
  position: relative;
  width: 100%;
`

export const CloseIcon = styled(Close)`
  color: ${props => props.theme.palette.brand.black3};
  cursor: pointer;
  font-size: 1.5rem;
  position: absolute;
  right: 10px;
  top: -4px;
`

export const Heading = styled.h1`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 27px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 31px;
  margin: 0 0 20px;
  padding: 0;
  width: 100%;
`

export const Box = styled.div`
  background-color: ${props => props.theme.palette.gray[50.25]};
  margin: 0 0 20px;
  padding: 20px;
`

export const Row = styled(BaseGrid)`
  margin: 0 0 6px;
  padding: 0;
  width: 100%;

  &:last-child {
    margin: 0;
  }
`

export const Column = styled(({ before, maxWidth, padding, ...props }) => <BaseGrid {...props} />)`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  letter-spacing: 0;
  line-height: 18px;
  margin: 0;
  max-width: ${props => props.maxWidth || 'initial'};
  padding: ${props => props.padding || 0};

  ${props => props.theme.breakpoints.only('xs')} {
    max-width: initial;
    padding: 0;
  }

  &:last-child::before {
    content: ': ';

    ${props => props.theme.breakpoints.only('xs')} {
      content: '';
    }
  }
`

export const Strong = styled.span`
  font-weight: bold;
`

export const Announcement = styled(({ highlighted, ...props }) => <p {...props} />)`
  color: ${props => (props.highlighted ? props.theme.palette.brand.primary : props.theme.palette.brand.black1)};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  letter-spacing: 0;
  line-height: 18px;
  margin: 0;
  padding: 0;
`

export const Section = styled(({ display, margin, opaque, ...props }) => <section {...props} />)`
  background-color: ${props => (props.opaque ? props.theme.palette.custom.heather : 'initial')};
  display: ${props => props.display || 'block'};
  justify-content: ${props => {
    if (props.align === 'center') {
      return props.align
    }

    if (props.align === 'right') {
      return 'flex-end'
    }

    return 'flex-start'
  }};
  margin: ${props => props.margin || 0};
  padding: ${props => props.padding || 0};
  width: 100%;
`

export const NoDataCell = styled(TableCell)`
  border-bottom: 1px solid ${props => props.theme.palette.custom.dustyGray};
  padding: 5px 9px 5px 0;
`

export const Source = styled.p`
  color: ${props => props.theme.palette.gray[35]};
  font-size: 14px;
  font-style: italic;
  letter-spacing: 0;
  line-height: 18px;
  margin: 0;
  padding: 0;
`
